import LineAngleRightIcon from 'components/Luxkit/Icons/line/LineAngleRightIcon'
import TextLink from 'components/Luxkit/TextLink'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  padding: ${rem(8)} ${rem(16)};
  display: flex;
  align-items: center;
  overflow-x: auto;
  background-color: ${props => props.theme.palette.neutral.eight};
  border-bottom: 1px solid ${({ theme }) => theme.palette.neutral.six};

  > * {
    flex-shrink: 0;
  }

  ${mediaQueryUp.sm} {
    display: none;
  }
`

interface Props {
  items: App.BreadcrumbItem[];
}

function TopMobileRelatedTravelItems({ items }: Props) {
  const nonCurrentItems = items.slice(0, -1)

  return <Wrapper>
    {nonCurrentItems.map((item, index) => <TextLink
      key={index}
      weight="regular"
      size="caption"
      to={item.url}
      startIcon={index !== 0 && <LineAngleRightIcon size="XS" />}>
      {item.text}
    </TextLink>)}
  </Wrapper>
}

export default TopMobileRelatedTravelItems
